import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { LoginPopupComponent } from "../login-popup/login-popup.component";
import { Observable, tap } from "rxjs";
import { ModalService } from "src/app/services/modal.service";
import { filter } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { HelpersService, AuthService, LanguageService } from "@evento-ng/libs";
import {
  EVENT_NAME_AR,
  EVENT_NAME_EN,
  INSTAGRAM_URL,
  TWITTER_URL,
  LINKEDIN_URL,
} from "src/app/services/constants/general.constants";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  activeLink: string = "";
  showMobileMenu: boolean | undefined;
  user$: Observable<any>;
  isAuthenticated = false;
  isEventRoute: boolean = false;
  eventNameAr: string = "";
  eventNameEn: string = "";

  INSTAGRAM_URL = INSTAGRAM_URL;
  TWITTER_URL = TWITTER_URL;
  LINKEDIN_URL = LINKEDIN_URL;

  constructor(
    private languageService: LanguageService,
    private router: Router,
    public translate: TranslateService,
    private modalService: NgbModal,
    private authService: AuthService,
    private newModalService: ModalService,
    private helpers: HelpersService
  ) {
    this.user$ = this.authService.user$.pipe(
      tap((user: any) => {
        this.isAuthenticated = !!user;
      })
    );

    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.isEventRoute =
          event.urlAfterRedirects.startsWith("/event-details") ||
          event.urlAfterRedirects.startsWith("/validate") ||
          event.urlAfterRedirects.startsWith("/book");

        this.eventNameAr = this.helpers.getItemFromLocalStorage(EVENT_NAME_AR);
        this.eventNameEn = this.helpers.getItemFromLocalStorage(EVENT_NAME_EN);
      });
  }

  ngOnInit(): void {
    this.newModalService.modal$.subscribe((modalType: any) => {
      if (modalType === "resetLogin") {
        this.openModal("login");
      }
    });
  }

  public onSwitchLanguages(): void {
    this.languageService.switchLanguages();
  }

  closeDropdown(): void {
    this.showMobileMenu = false;
  }

  scrollToElement(element: any): void {
    this.router.navigate(["/home"], { fragment: element });
    this.showMobileMenu = false;
    this.router.navigateByUrl("/home");
    document.getElementById(element)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  }

  scrollTo(section: any) {
    this.scrollToElement(section);
    event!.preventDefault();
    this.activeLink = section;
    this.closeDropdown();
  }

  openModal(formType: any): void {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      centered: true,
    };

    const modalRef = this.modalService.open(
      LoginPopupComponent,
      ngbModalOptions
    );
    modalRef.componentInstance.formToShow = formType;

    modalRef.dismissed.subscribe((result: any) => {
      if (result) {
      }
    });
  }

  logout(): void {
    this.authService.logout().subscribe({
      next: () => {
        console.log("Logout successful");
        this.router.navigate(["/"]);
      },
      error: (err: any) => {
        console.error("Logout error:", err);
      },
    });
  }
}
